/*
  Storage of sorting, pagination and filtering
 */
export default {
  state: {
    orderPaginationSort: {
      groupBy: [],
      groupDesc: [],
      itemsPerPage: 10,
      mustSort: false,
      multiSort: false,
      page: 1,
      sortBy: [],
      sortDesc: []
    },
    orderFilter: {
      search: '',
      tariffZone: '',
      statuses: [],
      userTypes: '',
      rideTypes: [],
      classes: [],
      legalEntities: [],
      datePickerStart: null,
      datePickerEnd: null,
      timePickerStart: null,
      timePickerEnd: null
    }
  },
  mutations: {
    SET_ORDER_PAGINATION_SORT (state, payload) {
      state.orderPaginationSort = payload
    },
    SET_ORDER_FILTER (state, payload) {
      state.orderFilter = payload
    }
  },
  actions: {
    orderPaginationSort ({ commit }, payload) {
      commit('SET_ORDER_PAGINATION_SORT', payload)
    },
    orderFilter ({ commit }, payload) {
      commit('SET_ORDER_FILTER', payload)
    }
  }
}
